const defaultTextSize = 'text-sm md:text-base'

const states = {
  SMA: {
    classes: 'bg-green-100 text-green-800',
    // label: 'Solicitud de Menor autorizada',
  },

  SGC: {
    classes: 'bg-blue-100 text-blue-800',
    // label: 'Solicitud general creada',
  },

  SGA: {
    classes: 'bg-green-100 text-green-800',
    // label: 'Solicitud general autorizada',
  },

  SGE: {
    classes: 'bg-red-100 text-red-800',
    // label: 'Solicitud general con error',
  },

  SMC: {
    classes: 'bg-blue-100 text-blue-800',
    // label: 'Solicitud de Menor creada',
  },

  SME: {
    classes: 'bg-red-100 text-red-800',
    // label: 'Solicitud de Menor con error',
  },
  RTP: {
    classes: 'bg-orange-100 text-orange-800',
    // label: 'Revocatoria total pendiente',
  },
  RTV: {
    classes: 'bg-green-100 text-green-800',
    // label: 'Revocatoria total verificada',
  },
  PPR: {
    classes: 'bg-yellow-100 text-yellow-800',
    // label: 'Pendiente de presentación',
  },
}

export default {
  props: {
    estado: { type: Object, required: true },
    textSizeClass: { type: String, default: defaultTextSize },
  },

  computed: {
    colour() {
      return states[this.estado.estadoId].classes
    },

    textSize() {
      return this.textSizeClass || defaultTextSize
    },
  },

  render() {
    return (
      <span
        class={`inline-flex items-center rounded-full px-3 pb-px pt-0.5 font-medium ${this.textSize} ${this.colour}`}
      >
        {this.estado.descripcion}
      </span>
    )
  },
}
